import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-red-900/20 text-gray-400">
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-display font-bold text-white mb-4">
              EWS PRODUCTIONS
            </h3>
            <p className="text-sm leading-relaxed">
              Cinematic environments for film, fashion, and alternative creative productions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-mono text-xs tracking-widest uppercase mb-4">
              Services
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/studio-hire" className="text-sm hover:text-red-400 transition-colors">
                  Studio Hire
                </Link>
              </li>
              <li>
                <Link to="/bespoke-set-design-construction" className="text-sm hover:text-red-400 transition-colors">
                  Set Design & Construction
                </Link>
              </li>
              <li>
                <Link to="/fashion-events" className="text-sm hover:text-red-400 transition-colors">
                  Fashion & Events
                </Link>
              </li>
              <li>
                <Link to="/boudoir-intimate-photography" className="text-sm hover:text-red-400 transition-colors">
                  Boudoir Photography
                </Link>
              </li>
              <li>
                <Link to="/scene-production" className="text-sm hover:text-red-400 transition-colors">
                  Scene Production
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-red-400 transition-colors">
                  Gallery
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h4 className="text-white font-mono text-xs tracking-widest uppercase mb-4">
              Information
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm hover:text-red-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/freelance-models" className="text-sm hover:text-red-400 transition-colors">
                  Freelance Models
                </Link>
              </li>
              <li>
                <Link to="/model-signup" className="text-sm hover:text-red-400 transition-colors">
                  Model Sign Up
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-red-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/booking-terms" className="text-sm hover:text-red-400 transition-colors">
                  Booking Terms
                </Link>
              </li>
              <li>
                <a href="#privacy" className="text-sm hover:text-red-400 transition-colors">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-mono text-xs tracking-widest uppercase mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-red-500 mt-0.5" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm hover:text-red-400 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-red-500 mt-0.5" />
                <span className="text-sm">{contactInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-red-500 mt-0.5" />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-red-900/20 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} EWS Productions. All rights reserved. Professional, consent-led creative environments.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;